module.exports = __webpack_public_path__ + "img/menu-invoices.042a15b3.svg";